import { ChevronDown, User } from 'lucide-react';
import type { VirtualUser } from '../../api/virtualUser';

function virtualUserLabel(u: VirtualUser) {
  const name = u.display_name?.trim() || u.user_id?.trim() || u.id;
  return `${name} · ${u.mode === 'attach' ? '挂载衣橱' : '克隆衣橱'} · ${u.item_count}件`;
}

interface Props {
  virtualUsers: VirtualUser[];
  selected: VirtualUser | null;
  onSelect: (u: VirtualUser) => void;
}

export function VirtualUserSelect({ virtualUsers, selected, onSelect }: Props) {
  return (
    <label className="relative inline-flex items-center gap-2 text-sm min-w-0">
      <User className="w-4 h-4 text-[var(--muted)] shrink-0" />
      <select
        className="appearance-none bg-[var(--paper)] border border-[var(--line)] rounded-[var(--radius-sm)] pl-3 pr-8 py-1.5 text-sm max-w-[280px] truncate"
        value={selected?.id ?? ''}
        onChange={(e) => {
          const u = virtualUsers.find((x) => x.id === e.target.value);
          if (u) onSelect(u);
        }}
      >
        {virtualUsers.map((u) => (
          <option key={u.id} value={u.id}>
            {virtualUserLabel(u)}
          </option>
        ))}
      </select>
      <ChevronDown className="w-3.5 h-3.5 text-[var(--muted)] absolute right-2 pointer-events-none" />
    </label>
  );
}
